//
//
//
//
//
//
//
//
//
//

export default {
  name: "SfOverlay",
  props: {
    transition: {
      type: String,
      default: "moomin-fade",
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
